/**
 * Whether a camera points away from the person using it — a phone's back
 * camera. Your own picture is mirrored so that it behaves like a mirror, which
 * is right for a camera facing you and wrong for one facing the room: the
 * scene comes out reversed, text included.
 *
 * The track's own `facingMode` decides when the browser reports it (Chrome and
 * Safari on phones do). Otherwise the device label is the only hint: iOS
 * names it "Back Camera", Android "camera2 0, facing back". A laptop webcam
 * reports neither, and is treated as facing you.
 */
export function cameraFacesAway(camera: { facingMode?: string; label?: string } | null | undefined): boolean {
  if (!camera) return false
  if (camera.facingMode === 'environment') return true
  if (camera.facingMode === 'user') return false
  return /\b(back|rear|environment)\b/i.test(camera.label ?? '')
}

/** The same question, asked of a live track. */
export function trackFacesAway(track: MediaStreamTrack | null | undefined): boolean {
  if (!track) return false
  const settings = typeof track.getSettings === 'function' ? track.getSettings() : {}
  return cameraFacesAway({ facingMode: settings.facingMode, label: track.label })
}
